<template>
  <div class="home-container">
    <div class="home-header">
      <img class="logo-img" src="../assets/logo.svg" />
      <img class="slogn-img" src="../assets/slogn.svg" />
      <div class="common-btn get-detail" @click="onDetail()">
        <span>了解详情</span>
      </div>
    </div>
    <div class="home-content">
      <div class="function-section">
        <div class="function-box">
          <img src="../assets/chuantou.svg"/>
          <span class="function-title">一键互联</span>
          <span class="function-desc">轻松连接电脑、手机、NAS、服务器</span>
        </div>
        <div class="function-box">
          <img src="../assets/assist.svg"/>
          <span class="function-title">无缝协同</span>
          <span class="function-desc">跨设备文件访问与远程控制</span>
        </div>
        <div class="function-box">
          <img src="../assets/shield.svg"/>
          <span class="function-title">安全直达</span>
          <span class="function-desc">稳定加密，保障连接与数据隐私</span>
        </div>
      </div>
      <div class="second-title"><img src="../assets/second-title.svg" /></div>
      <div class="system-section">
        <div class="system-box">
          <img src="../assets/Nas.svg">
          <span>Nas</span>
        </div>
        <div class="system-box">
          <img src="../assets/win.svg">
          <span>Windows</span>
        </div>
        <div class="system-box">
          <img src="../assets/mac.svg">
          <span>mac OS</span>
        </div>
        <div class="system-box">
          <img src="../assets/android.svg">
          <span>Android</span>
        </div>
        <div class="system-box">
          <img src="../assets/iOS.svg">
          <span>iOS</span>
        </div>
        <div class="system-box">
          <img src="../assets/docker.svg">
          <span>Docker</span>
        </div>
      </div>
      <div class="common-btn download-btn" @click="onDownload()">
        <span>下载app</span>
      </div>
      <div class="download-warning">PC、NAS请前往官网下载</div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
     
    };
  },
  methods: {
    onDetail(){
      window.open('https://iepose.com');
    },
    goUrl: function (url) {
      window.location.href = url;
    },
    isMobileDevice: function () {
      // 这些正则表达式用于匹配常见的移动设备和浏览器用户代理
      var mobileRegex =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

      // 检查用户代理字符串是否包含上述任何正则表达式
      return mobileRegex.test(navigator.userAgent);
    },
    isAndroidDevice: function () {
      // 这些正则表达式用于匹配常见的移动设备和浏览器用户代理
      var mobileRegex = /Android/i;

      // 检查用户代理字符串是否包含上述任何正则表达式
      return mobileRegex.test(navigator.userAgent);
    },
    isAppleDevice: function () {
      // 这些正则表达式用于匹配常见的移动设备和浏览器用户代理
      var mobileRegex = /iPhone|iPad|iPod/i;

      // 检查用户代理字符串是否包含上述任何正则表达式
      return mobileRegex.test(navigator.userAgent);
    },

    isWeixin: function () {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    onDownload(){
      // window.open('https://iepose.com/jdxb/pc/download');
      let _that = this;
      if (_that.isWeixin() && _that.isAppleDevice()) {
        _that.goUrl("https://tan.ionewu.com/api/jdxb/download/v2/yingyongbao");
      } else if (_that.isAppleDevice()) {
        _that.goUrl("https://tan.ionewu.com/api/jdxb/download/v2/ios_appstore");
      } else if (_that.isAndroidDevice()) {
        _that.goUrl("https://tan.ionewu.com/api/jdxb/download/v2/android");
      } else {
        _that.goUrl("https://www.iepose.com/download");
      }
    }
  },
  mounted() {
    
  },
};
</script>

<style scoped lang="less">
.home-container{
  width: 100vw;
  min-height: 100vh;
  overflow-x: hidden;
  background-color: rgba(20, 31, 60, 1);
  background-image: url("../assets/main_bg.jpg");
  background-position: left top;
  background-size: 100% auto;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .common-btn{
    border-radius: 6px;
    background: linear-gradient(90.00deg,
      rgba(55, 114, 255, 1),
      rgba(170, 86, 255, 1) 36%,
      rgba(255, 104, 56, 1) 65%,
      rgba(255, 153, 36, 1) 100%);
      display: flex;
      align-items: center;
      justify-content: center;
  }
  .common-btn:active{
    background: linear-gradient(90.00deg,
      rgb(80, 129, 243),
      rgb(184, 121, 247) 36%,
      rgb(252, 136, 101) 65%,
      rgb(253, 174, 84) 100%);
  }
  .home-header{
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 270px;
    .logo-img{
      width: 139px;
      margin-bottom: 9px;
    }
    .slogn-img{
      width: 278px;
      margin-bottom: 13px;
    }
    .get-detail{
      width: 100px;
      height: 30px;
      color:  rgba(255, 255, 255, 1);
      font-size: 14px;
      font-weight: 500;
      line-height: 21px;
      letter-spacing: 0px;
      text-align: center;
    }
  }
  .home-content{
    .function-section{
      padding: 0 12px;
      display: flex;
      // justify-content: space-between;
      .function-box{
        height: 130px;
        box-sizing: border-box;
        border-radius: 8px;
        backdrop-filter: blur(5px);
        padding: 18px 12px 0 12px;
        background: linear-gradient(180.00deg,
         rgba(255, 255, 255, 0.1),
         rgba(255, 255, 255, 0) 100%);
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
        img{
          width: 30px;
          height: 30px;
        }
        margin-right: 10px;
        .function-title{
          color: rgba(255, 255, 255, 1);
          font-size: 13px;
          font-weight: 500;
          line-height: 20px;
          letter-spacing: 0px;
          text-align: center;
          margin-top: 9px;
        }
        .function-desc{
          color: rgba(116, 121, 141, 1);
          font-size: 10px;
          font-weight: 400;
          line-height: 16px;
          letter-spacing: 0px;
          text-align: center;
          margin-top: 7px;
        }
      }
      .function-box:last-child{
        margin-right: 0;
      }
    }
    .second-title{
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 18px 0 15px 0;
    }
    .system-section{
      justify-content: center;
      display: grid;
      grid-template-columns: repeat(auto-fill, 110px);
      grid-gap: 10px;
      grid-template-rows: 83px 83px;
      .system-box{
        border-radius: 11.05px;
        backdrop-filter: blur(8px);
        background: linear-gradient(180.00deg, 
        rgba(34, 55, 117, 0.5),
        rgba(34, 55, 117, 0) 100%);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        img{
          width: 28px;
          height: 28px;
          margin-bottom: 10px;
        }
        span{
          color: rgba(255, 255, 255, 1);
          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
          letter-spacing: 0px;
          text-align: center;
        }
      }
    }
    .download-btn{
      border-radius: 12px;
      width: 320px;
      height: 48px;
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
      margin: 20px auto 13px;
    }
    .download-warning{
      color: rgba(177, 181, 196, 1);
      font-family: Source Han Sans CN;
      font-style: Regular;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: 0px;
      text-align: center;
      margin:0 auto 20px;
    }
  }
}
</style>

